import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedDevolucionesComponent {
  acceso_proyecto = false
  agregarDevolucion = false
  autorizado = false
  catalogos = {
    gasto_categoria: [],
    moneda: [],
  }
  data = []
  id_nomina = null
  idColaborador
  idProyecto
  comprobaciones
  informacion
  maquilando = false
  opcion = null
  operadora
  saldo = 0
  totalDevoluciones = 0
  ultimo = false
  viaje
  viaticoId
  onChange

  constructor ($q, $state, ViaticosViaticoDevolucionesService, ViaticosCatalgosCategoriasviaticoService, ViaticosCatalogosMonedasService) {
    this.$q = $q
    this.$state = $state
    this.ViaticosViaticoDevolucionesService = ViaticosViaticoDevolucionesService
    this.ViaticosCatalgosCategoriasviaticoService = ViaticosCatalgosCategoriasviaticoService
    this.ViaticosCatalogosMonedasService = ViaticosCatalogosMonedasService
  }

  $onChanges (changes) {
    if (changes.comprobaciones && !changes.comprobaciones.isFirstChange()) {
      this.totalizar()
    }
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ViaticosCatalgosCategoriasviaticoService.get()
        .then(({data}) => (this.catalogos.gasto_categoria = data)),
      this.ViaticosCatalogosMonedasService.get()
        .then(({data}) => (this.catalogos.moneda = data)),
    ])
    this.data = this.data ? this.data : []
    if (!this.viaticoId) return
    this.totalizar()
  }

  agregar (data) {
    this.data = [...this.data, ...data]
    this.agregarDevolucion = false
    this.totalizar()
    this.onChange({$event: {detail: this.data}})
  }

  totalizar () {
    this.permiteSolicitar = this.saldo < 0 && this.comprobaciones.every((solicitud) => !solicitud.id_nomina)
    this.totalDevoluciones = this.data.reduce((total, item) => total + (item.autorizado ? item.total : 0), 0)
    if (this.data.length) {
      this.ultimo = this.data.every((item) => item.ultimo)
      this.autorizado = this.data.every((item) => item.autorizado)
      this.acceso_proyecto = this.data[0].acceso_permitido || false
      this.id_nomina = this.data[0].id_nomina || null
      this.solicitud_id = this.data[0].solicitud_id || null
    }
  }

  actualizar (item, data) {
    if (!data) {
      this.data.splice(this.data.findIndex((solicitud) => solicitud.solicitud_id === item.solicitud_id), 1)
    } else {
      Object.assign(item, data)
    }
    this.totalizar()
    this.onChange({$event: {detail: this.data}})
  }

  finalizar (data) {
    this.maquilando = false
    if (!data.nomina) return

    this.id_nomina = data.id_nomina
    if (data.redireccionar) {
      this.redireccionarNomina()
    }
  }

  redireccionarNomina () {
    this.$state.go('nominas.detalladoNomina.colaboradores', {idEmpresa: this.idProyecto, idNomina: this.id_nomina})
  }
}

module.component('viaticosSharedDevoluciones', {
  controller: ViaticosSharedDevolucionesComponent,
  template,
  bindings: {
    data: '<',
    idColaborador: '<',
    idProyecto: '<',
    comprobaciones: '<',
    informacion: '<',
    operadora: '<',
    viaje: '<',
    saldo: '<',
    viaticoId: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/devoluciones/component.js